/**
 * Deshabilita el botón en el mismo tick del click y opcionalmente muestra texto de espera.
 * @param {HTMLButtonElement | null} buttonEl
 * @param {() => void | Promise<void>} task
 * @param {{ labelBusy?: string }} [options] labelBusy vacío = solo disable + aria-busy (sin cambiar HTML)
 */
export async function withBusyButton(buttonEl, task, options = {}) {
  if (!buttonEl || buttonEl.dataset.busy === '1') return;
  const labelBusy = options.labelBusy !== undefined ? options.labelBusy : 'Procesando…';

  if (buttonEl._mlvBusyHtml == null) {
    buttonEl._mlvBusyHtml = buttonEl.innerHTML;
  }

  buttonEl.dataset.busy = '1';
  buttonEl.disabled = true;
  buttonEl.classList.add('btn-async', 'is-busy', 'cursor-wait', 'opacity-90');
  buttonEl.setAttribute('aria-busy', 'true');
  if (labelBusy) {
    buttonEl.textContent = labelBusy;
  }

  try {
    await task();
  } finally {
    buttonEl.dataset.busy = '0';
    buttonEl.disabled = false;
    buttonEl.classList.remove('is-busy', 'cursor-wait', 'opacity-90');
    buttonEl.removeAttribute('aria-busy');
    const saved = buttonEl._mlvBusyHtml;
    if (saved != null) buttonEl.innerHTML = saved;
  }
}
